import isPlainObject from 'lodash/isPlainObject';
import { isNotNull } from 'utils/tsHelpers';
import { parseDate } from 'utils/datetime';
import { isEpochDate } from 'utils/validateDate';
import { ConditionDateRange } from './types';

export const isNotNullDateRange = (dateRange: ConditionDateRange | null) => {
  return isNotNull(dateRange) && isNotNull(dateRange?.startDate) && isNotNull(dateRange?.endDate);
};

const convertDateToEpoch = (date: string) =>
  !isEpochDate(date) ? parseDate(date).getTime().toString() : date;

export const getOnDateRangeChange = ({
  startDate,
  endDate,
}: {
  startDate: string | null;
  endDate: string | null;
}): ConditionDateRange => {
  if (isNotNullDateRange({ startDate, endDate })) {
    const parsedStartDate = isNotNull(startDate) && convertDateToEpoch(startDate);
    const parsedEndDate = isNotNull(endDate) && convertDateToEpoch(endDate);
    return { startDate: parsedStartDate || null, endDate: parsedEndDate || null };
  }
  return { startDate: null, endDate: null };
};

export const getDefaultDateRange = (value?: ConditionDateRange | string | null) => {
  if (isPlainObject(value)) {
    return value as ConditionDateRange;
  }
  const valueInt = parseInt(value as string, 10);
  const defaultDate = !!valueInt ? new Date(valueInt) : new Date();
  const endDate = defaultDate.getTime().toString();
  const startDate = defaultDate.setDate(defaultDate.getDate() - 7).toString();
  return { endDate, startDate };
};
